import { post, get, postJson } from '../request';
import urls from './apilist';

const apis = {
  getGoodsList,
  getSupplierList,
  getOneGoodsTypeList,
  enSaleOrUnSale,
  batchDeleteGoods,
  saveOrUpdateGoods,
  getNextGoodsType,
  getBaseTypes,
  getSpecListByGoodsTypeId,
  getBaseAttributeList,
  getGoodsById,
  getGoodsNum,
  setBannerClick,
  setSupplierClick,
  setGoodsClick,
  getGoodsByName,
  getGoodsCode,
  getEvaluateByGoodsId,
  getSupplierTelePhone

};

/**
 * 获取商品列表
 */
function getGoodsList(params) {
  return get(urls.getGoodsList, params);
}
/**
 * 获取供应商列表
 * @param params
 * @returns {*}
 */
function getSupplierList(params) {
  return get(urls.getSupplierList, params);
}
/**
 * 获取商品分类列表
 * @param params
 * @returns {*}
 */
function getOneGoodsTypeList(params) {
  return get(urls.getOneGoodsTypeList, params);
}

/**
 * 获取二级分类
 * @param params
 * @returns {*}
 */
function getNextGoodsType(params) {
  return get(urls.getNextGoodsType, params);
}
/**
 * 上架，下架
 * @param params ids
 * @returns {*}
 */
function enSaleOrUnSale(params) {
  return post(urls.enSaleOrUnSale, params);
}

/**
 * 批量删除商品
 * @param params
 * @returns {*}
 */
function batchDeleteGoods(params) {
  return post(urls.batchDeleteGoods, params);
}

/**
 * 新增商品
 * @param params
 * @returns {*}
 */
function saveOrUpdateGoods(params) {
  return postJson(urls.saveOrUpdateGoods, params);
}

/**
 * 获取商品类型
 * @param params
 * @returns {*}
 */
function getBaseTypes(params) {
  return get(urls.getBaseTypes, params);
}

/**
 * 根据商品类型获取商品规格
 * @param params
 * @returns {*}
 */
function getSpecListByGoodsTypeId(params) {
  return get(urls.getSpecListByGoodsTypeId, params);
}

/**
 * 根据商品类型获取商品参数
 *  goodsBaseTypeId：商品类型id
    type：0 规格  1 属性
 * @param params
 * @returns {*}
 */
function getBaseAttributeList(params) {
  return get(urls.getBaseAttributeList, params);
}

/**
 * 根据商品id获取商品详情
 * @param params
 * @returns {*}
 */
function getGoodsById(params) {
  return get(urls.getGoodsById, params);
}

/**
 * 获取商品库存
 * @param params
 * @returns {*}
 */
function getGoodsNum(params) {
  return get(urls.getGoodsNum, params);
}

/**
 * 轮播图埋点
 * @param params
 * @returns {*}
 */
function setBannerClick(id) {
  return post(urls.setBannerClick, {id});
}

/**
 * 首页推荐供应商埋点
 * @param params
 * @returns {*}
 */
function setSupplierClick(id) {
  return post(urls.setSupplierClick, {id});
}

/**
 * 首页推荐商品埋点
 * @param id
 * @returns {*}
 */
function setGoodsClick(id) {
  return post(urls.setGoodsClick, {id})
}

/**
 *根据商品名称搜索商品
 * @param key
 * @returns {*}
 */
function getGoodsByName(params) {
  return get(urls.getGoodsByName, params)
}

/**
 * 分享时生成二维码
 * @param params
 * @returns {*}
 */
function getGoodsCode(content) {
  return get(urls.getGoodsCode, {content})
}

/**
 * 根据商品id获取评论
 * @param params
 * @returns {*}
 */
function getEvaluateByGoodsId(params) {
  return get(urls.getEvaluateByGoodsId, params)
}

//获取商品所属供应商的客服电话
function getSupplierTelePhone(goodsId) {
  return get(urls.getSupplierTelePhone, {goodsId})
}
export default apis;
